import { render, staticRenderFns } from "./ProformeProductie.vue?vue&type=template&id=55b8cf5a&scoped=true"
import script from "./ProformeProductie.vue?vue&type=script&lang=js"
export * from "./ProformeProductie.vue?vue&type=script&lang=js"
import style0 from "./ProformeProductie.vue?vue&type=style&index=0&id=55b8cf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8cf5a",
  null
  
)

export default component.exports